module.exports = __webpack_public_path__ + "media/images/flags/4x3/vnm-aa591eadf9bfbc055224fa840e067013.svg";